import { render, staticRenderFns } from "./pointsExchangeOrder.vue?vue&type=template&id=1433393c&scoped=true"
import script from "./pointsExchangeOrder.vue?vue&type=script&lang=js"
export * from "./pointsExchangeOrder.vue?vue&type=script&lang=js"
import style0 from "./pointsExchangeOrder.vue?vue&type=style&index=0&id=1433393c&prod&lang=less&scoped=true"
import style1 from "./pointsExchangeOrder.vue?vue&type=style&index=1&id=1433393c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1433393c",
  null
  
)

export default component.exports